import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61c04d1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-aside-navigator__bottom" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "展开导航栏", -1))


const __default__ = {
  name: 'AsideDrawer'
}

import Icon from '@teams/common/components/icon'
import { VerticalNavs } from '@/components/navigator'
import useNav from '@/components/navigator/useNav'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    expanding: { type: Boolean },
    toggleExpanding: null,
    onMouseLeave: null
  },
  setup(__props: any) {



const { showNavBarOptions } = useNav()

return (_ctx: any,_cache: any) => {
  const _component_n_scrollbar = _resolveComponent("n-scrollbar")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "base-aside-navigator",
    onContextmenu: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(showNavBarOptions) && _unref(showNavBarOptions)(...args)), ["prevent","stop"])),
    onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (__props.onMouseLeave && __props.onMouseLeave(...args)))
  }, [
    _createVNode(_component_n_scrollbar, {
      style: _normalizeStyle({
        flex: 1,
        paddingRight: __props.expanding ? '12px' : 0
      })
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(VerticalNavs))
      ]),
      _: 1
    }, 8, ["style"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['bottom-icon', { 'bottom-icon__collapse': __props.expanding }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.toggleExpanding && __props.toggleExpanding(...args)))
      }, [
        _createVNode(_component_n_tooltip, {
          trigger: "hover",
          placement: "right"
        }, {
          trigger: _withCtx(() => [
            _createVNode(_unref(Icon), {
              name: "packUp1",
              fill: "transparent",
              stroke: "#161819"
            })
          ]),
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ], 2)
    ])
  ], 32))
}
}

})